import { useRef, useState } from "react";
import { SystemCore } from "../../../../Core/System/SystemCore";
import { SystemDataLoadingStatus, SystemPageType } from "../../../../Model/SystemModels";
import { Loader } from "../../../Common/Loader/Loader";
import { ListHeaderEntry } from "../../../Common/Template/List/ListHeaderEntry";
import PageContainer, { PageContainerBase } from "../../../Common/Template/PageContainer";
import { ContainerType, PageDefinitionContainer } from "../../../Common/Template/PageDefinitionContainer";
import { AdminBookingStaffMemberCard } from "../AdminBookingStaffMemberCard/AdminBookingStaffMemberCard";

export const AdminBookingStaffMemberList : React.FC = () => {    
    const [dataStatus, setDataStatus] = useState(SystemDataLoadingStatus.Loaded);
    const [loaderMessage, setLoaderMessage] = useState("");
    const cardRef = useRef<PageContainerBase>(null);
    
    if (!SystemCore.isFinishedDataStatus(dataStatus))
        return <Loader text={loaderMessage}></Loader>;
    else
        return (
            <>
                <PageContainer endpoint={'/odata/booking/staff/member'} pageType={SystemPageType.List} title={"Booking staff members"} cardRef={cardRef} backAllowed showAllowed updateAllowed>
                    <PageDefinitionContainer type={ContainerType.Action}></PageDefinitionContainer>
                    <PageDefinitionContainer type={ContainerType.PageStructure}>
                        <ListHeaderEntry fieldName="calendarId" name="Calendar Id" minWidth={100} maxWidth={200} />
                        <ListHeaderEntry fieldName="id" name="Id" minWidth={100} maxWidth={200} />
                        <ListHeaderEntry fieldName="displayName" name="Name" minWidth={300} maxWidth={400} />
                        <ListHeaderEntry fieldName="emailAddress" name="Email" minWidth={300} maxWidth={400} />
                        <ListHeaderEntry fieldName="role" name="Role" minWidth={150} maxWidth={200} />
                        <ListHeaderEntry fieldName="userId" name="User Id" minWidth={200} maxWidth={300} />
                    </PageDefinitionContainer>
                </PageContainer>
                <AdminBookingStaffMemberCard ref={cardRef} />
            </>
        );
}